export default __webpack_public_path__ + "static/media/img-result-a-small@2x.6d3d76fc.png";